import { Component } from '@angular/core';


@Component({
    selector: 'app-easter-faq',
    imports: [],
    styleUrls: ['./faq.component.scss'],
    template: `
        <div class="faq-gradient tw-py-4 tw-px-5 md:tw-px-6 lg:tw-px-10 upper-side-shadow-top">
          <h2 class="tw-font-poppins tw-text-center tw-text-neutral-700 faq-title">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>
        <div class="tw-w-full down-arrow"></div>
        <div class="tw-py-20 tw-px-5 md:tw-px-10 lg:tw-px-20" style="background-color: #465052;">
          <div class="tw-flex tw-flex-col tw-gap-3 tw-max-w-4xl tw-mx-auto">
            @for (item of faqs; track $index; let i = $index) {
              <div
                class="tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 tw-overflow-hidden"
                >
                <button
                  class="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-text-left tw-font-semibold tw-font-poppins tw-text-neutral-800 tw-text-base md:tw-text-lg"
                  (click)="toggle(i)"
                  >
                  <span>{{ item.question }}</span>
                  <svg
                    class="tw-w-8 tw-h-8 tw-flex-shrink-0 tw-ml-3 tw-transition-transform tw-duration-300"
                    [class.tw-rotate-180]="item.open"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                @if (item.open) {
                  <div class="tw-px-6 tw-pb-4 tw-font-poppins tw-text-base md:tw-text-lg tw-text-neutral-600" [innerHTML]="item.answer">
                  </div>
                }
              </div>
            }
          </div>
          <p class="tw-text-center tw-text-sm md:tw-text-base tw-font-poppins tw-text-neutral-300 tw-mt-6">
            If you have any further questions about the Nustone Easter Mega Sale, please feel free to contact us directly at
            <a href="mailto:media@nustone.co.uk" class="tw-underline" style="color: #f7d403;">support&#64;nustone.co.uk</a>
          </p>
        </div>
        `
})
export class EasterFaqComponent {
    faqs = [
        {
            question: 'What is the Nustone Easter Mega Sale and how does it work?',
            answer: 'The Nustone Easter Mega Sale is a limited-time offer where customers can get a flat 10% discount on all products across the website. Simply add your items to the cart, apply the promo code at checkout, and the discount will be applied instantly.',
            open: false,
        },
        {
            question: 'Is there a minimum order value for the Nustone Easter Mega Sale?',
            answer: 'To qualify for the Nustone Easter Mega Sale, your total order value must be at least £1,000. Orders below this amount will not be eligible for the discount.',
            open: false,
        },
        {
            question: 'Does the Nustone Easter Mega Sale apply to all products?',
            answer: 'Yes, the Nustone Easter Mega Sale applies to everything available on the website, including paving, garden furniture, planters, fireplaces, accessories, and even the products that are on sale.',
            open: false,
        },
        {
            question: 'Can I combine the Nustone Easter Mega Sale with trade or affiliate discounts?',
            answer: 'No, the Nustone Easter Mega Sale cannot be combined with any other discounts, including trade pricing, affiliate codes, or other promotional offers.',
            open: false,
        },
        {
            question: 'How do I apply the discount in the Nustone Easter Mega Sale?',
            answer: 'To use the Nustone Easter Mega Sale offer, simply enter the promo code <b>EASTER10</b> at checkout, and the 10% discount will be applied to your eligible order.',
            open: false,
        },
        {
            question: ' Is the Nustone Easter Mega Sale available for a limited time only?',
            answer: 'Yes, the Nustone Easter Mega Sale is a limited-time campaign and will only be available between the announced campaign dates. We recommend placing your order early to avoid missing out.',
            open: false,
        },
        {
            question: 'Can Nustone trade customers or Nustone affiliates use the Nustone Easter Mega Sale?',
            answer: 'Yes, Nustone affiliates and trade customers can choose to use the Nustone Easter Mega Sale instead of their trade discount if it provides better value for their order.',
            open: false,
        },
        {
            question: 'Will the Nustone Easter Mega Sale discount apply automatically?',
            answer: 'No, the discount will not apply automatically. You must enter the promo code at checkout to activate the Nustone Easter Mega Sale offer.',
            open: false,
        },
        {
            question: 'What happens if I forget to apply the code during the Nustone Easter Mega Sale?',
            answer: 'If the promo code is not applied at checkout, the discount will not be added to the order, and it cannot be applied later on. Please ensure the code is entered before completing your purchase.',
            open: false,
        },
        {
            question: 'Is there any limit on how much I can save during the Nustone Easter Mega Sale?',
            answer: 'There is no upper limit on savings. The 10% discount applies to the total order value, so the more you spend (above £1,000), the more you save.',
            open: false,
        },
        {
            question: 'Can I use the Nustone Easter Mega Sale for multiple orders?',
            answer: 'Yes, the Nustone Easter Mega Sale can be used on multiple orders during the campaign period, as long as each order meets the minimum value requirement (i.e. £1,000).',
            open: false,
        },
    ];

    toggle(index: number): void {
        this.faqs[index].open = !this.faqs[index].open;
    }
}
